/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputPositionStockStatisticsItem
 */
export interface OutputPositionStockStatisticsItem {
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    currentBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    expendedLast30Days?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    expendedLast7Days?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    expendedToday?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    expendedYesterday?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputPositionStockStatisticsItem
     */
    stockItemId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputPositionStockStatisticsItem
     */
    stockItemName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputPositionStockStatisticsItem
     */
    stockItemType?: string;
}

/**
 * Check if a given object implements the OutputPositionStockStatisticsItem interface.
 */
export function instanceOfOutputPositionStockStatisticsItem(value: object): boolean {
    return true;
}

export function OutputPositionStockStatisticsItemFromJSON(json: any): OutputPositionStockStatisticsItem {
    return OutputPositionStockStatisticsItemFromJSONTyped(json, false);
}

export function OutputPositionStockStatisticsItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputPositionStockStatisticsItem {
    if (json == null) {
        return json;
    }
    return {
        
        'currentBalance': json['currentBalance'] == null ? undefined : json['currentBalance'],
        'expendedLast30Days': json['expendedLast30Days'] == null ? undefined : json['expendedLast30Days'],
        'expendedLast7Days': json['expendedLast7Days'] == null ? undefined : json['expendedLast7Days'],
        'expendedToday': json['expendedToday'] == null ? undefined : json['expendedToday'],
        'expendedYesterday': json['expendedYesterday'] == null ? undefined : json['expendedYesterday'],
        'stockItemId': json['stockItemId'] == null ? undefined : json['stockItemId'],
        'stockItemName': json['stockItemName'] == null ? undefined : json['stockItemName'],
        'stockItemType': json['stockItemType'] == null ? undefined : json['stockItemType'],
    };
}

export function OutputPositionStockStatisticsItemToJSON(value?: OutputPositionStockStatisticsItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currentBalance': value['currentBalance'],
        'expendedLast30Days': value['expendedLast30Days'],
        'expendedLast7Days': value['expendedLast7Days'],
        'expendedToday': value['expendedToday'],
        'expendedYesterday': value['expendedYesterday'],
        'stockItemId': value['stockItemId'],
        'stockItemName': value['stockItemName'],
        'stockItemType': value['stockItemType'],
    };
}

